import React from "react";
import { Tooltip, ResponsiveContainer, CartesianGrid, XAxis, YAxis, LineChart, Legend, Line } from "recharts";
import { convertCapitalize } from "../../../../utils/allFormatter";

const CustomizedAxisTick = (props) => {
  const { x, y, stroke, payload } = props;
  return (
    <g transform={`translate(${x},${y})`}>
      <text x={0} y={0} textAnchor="end" fill="#666">
        {payload.value}$
      </text>
    </g>
  );
};

export const MultiLineChart = (props) => {
  return (
    <ResponsiveContainer height={450} width="100%">
      <LineChart data={props?.data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="companyname" />

        <YAxis yAxisId="left" tick={<CustomizedAxisTick />} />
        <Tooltip />
        <Legend
          //   verticalAlign="top"
          height={40}
          content={(props) => {
            return (
              <ul className="d-flex justify-content-center my-3">
                {props.payload.map((entry, index) => (
                  <li key={`item-${index}`} className="ms-5 d-flex align-items-center">
                    <div
                      style={{
                        width: "15px",
                        height: "15px",
                        backgroundColor: `${entry.color}`,
                        marginRight: "5px",
                      }}
                    ></div>
                    {convertCapitalize(entry.value)}
                  </li>
                ))}
              </ul>
            );
          }}
        />
        <Line
          yAxisId="left"
          name="numberofclicks"
          type="monotone"
          dataKey="numberofclicks"
          stroke="#8884d8"
          strokeWidth={3}
        />
        <Line
          yAxisId="left"
          name="conversionrate"
          type="monotone"
          dataKey="conversionrate"
          stroke="#82ca9d"
          strokeWidth={3}
        />
        {/* <Line yAxisId="left" name="Company C" type="monotone" dataKey="companyC" stroke="#10439F" strokeWidth={3} /> */}
      </LineChart>
    </ResponsiveContainer>
  );
};
